export const enum MessageStatusesEnum {
  NotRunning = 'Not Running',
  Requested = 'Requested',
  Fetched = 'Fetched',
  Done = 'Done'
}
